import { inject, Injectable } from "@angular/core";
import { BackendApiService } from "./backend-api.service";
import { BaseUrlConstantsService } from "./base-url-constants.service";

@Injectable({
  providedIn: "root",
})
export class PiezeoService {
  private data: any = {
    data: [
      {
        master_type: "2",
        assetType: "MOTOR",
        subType: "INDUCTION_MOTOR",
        assetMarker: "MASTER",
        sensorMarker: "BASE",
        sensorDNames: "BASE",
        sensor_number: 0,
        x: 0,
        y: 0,
        xPercentage: 9.206349206349207,
        xPercentages: 9.206349206349207,
        xPercentageNet: 9.206349206349207,
        yPercentage: 45.28076463560334,
        yPercentages: 45.28076463560334,
        yPercentageNet: 45.28076463560334,
        associated: false,
        configured: false,
        form_configured: false,
      },
      {
        master_type: "4",
        assetType: "MOTOR",
        subType: "INDUCTION_MOTOR",
        assetMarker: "CHILD",
        sensorMarker: 1,
        sensorDNames: "NDE",
        sensor_number: 1,
        x: 0,
        y: 0,
        xPercentage: 27.513227513227513,
        xPercentages: 27.513227513227513,
        xPercentageNet: 27.513227513227513,
        yPercentage: 45.16129032258064,
        yPercentages: 45.16129032258064,
        yPercentageNet: 45.16129032258064,
        associated: false,
        configured: false,
        form_configured: false,
      },
    ],
    suybsystem_table_data: {
      subsystem_name: "TESTING PIEZO222",
      client_id: "2",
      Image_path:
        "https://qa-enertics-misc.s3.ca-central-1.amazonaws.com/images/1764053994540.png",
      subsystem_type: "piezeo",
    },
  };
  // ONLY PIEZO (TYPE--4)
  all_sensors: any = [
    {
      master_type: "4",
      assetType: "MOTOR",
      subType: "INDUCTION_MOTOR",
      assetMarker: "CHILD",
      sensorMarker: 1,
      sensorDNames: "NDE",
      sensor_number: 1,
      x: 0,
      y: 0,
      xPercentage: 27.513227513227513,
      xPercentages: 27.513227513227513,
      xPercentageNet: 27.513227513227513,
      yPercentage: 45.16129032258064,
      yPercentages: 45.16129032258064,
      yPercentageNet: 45.16129032258064,
      associated: false,
      configured: false,
      form_configured: false,
    },
  ];

  // RTD,STD,MINI (TYPE--1,2,3)
  emsavers_sensors: any = [
    {
      master_type: "2",
      assetType: "MOTOR",
      subType: "INDUCTION_MOTOR",
      assetMarker: "MASTER",
      sensorMarker: "BASE",
      sensorDNames: "BASE",
      sensor_number: 0,
      x: 0,
      y: 0,
      xPercentage: 9.206349206349207,
      xPercentages: 9.206349206349207,
      xPercentageNet: 9.206349206349207,
      yPercentage: 45.28076463560334,
      yPercentages: 45.28076463560334,
      yPercentageNet: 45.28076463560334,
      associated: false,
      configured: false,
      form_configured: false,
    },
  ];
  configured_gateways: any[] = [];
  gateways_to_delete: any = [];

  srv = inject(BackendApiService);

  //URLS
  DEVICE_LISTING_URL = BaseUrlConstantsService.energyMeterApi;

  constructor() {}

  setData(data: any) {
    this.data = data;
  }
  getData() {
    return this.data;
  }
  clearData() {
    this.data = {};
    this.all_sensors = {};
    this.configured_gateways = [];
  }
  setAllSensors(data: any) {
    this.all_sensors = data;
  }
  getAllSensors() {
    return this.all_sensors;
  }
  clearAllSensors() {
    this.all_sensors = {};
  }
  setEmsaverSensors(data: any) {
    this.emsavers_sensors = data;
  }
  getEmsaverSensors() {
    return this.emsavers_sensors;
  }
  clearEmsaverSensors() {
    this.emsavers_sensors = {};
  }
  setConfiguredGateways(data: any) {
    this.configured_gateways = [...this.configured_gateways, data];
  }
  setInitialConfiguredGateways(data: any[]) {
    this.configured_gateways = data;
  }
  getConfiguredGateways() {
    return this.configured_gateways;
  }
  clearConfiguredGateways() {
    this.configured_gateways = [];
  }

  updateGatewayInConfiguredList(updated_gateway: any) {
    this.configured_gateways = this.configured_gateways.map((gateway) => {
      if (gateway.gatewayAddress.id == updated_gateway.gatewayAddress.id) {
        return updated_gateway;
      }
      return gateway;
    });
  }
  editGatewayInConfiguredList(updated_gateway, old_id) {
    this.configured_gateways = this.configured_gateways.map((gateway) => {
      if (gateway.gatewayAddress.id === old_id) {
        return updated_gateway;
      }
      return gateway;
    });
  }
  deleteGatewayInConfiguredList(old_id) {
    this.configured_gateways = this.configured_gateways.filter(
      (gateway) => gateway.gatewayAddress.id != old_id
    );
  }

  setGatewaysToDelete(g) {
    this.gateways_to_delete.push(g);
  }

  reset() {
    this.configured_gateways = [];
    this.all_sensors = [];
    this.gateways_to_delete = [];
  }

  async fetchGatewayDeviceCategories(url) {
    try {
      const response: any = await this.srv.getDataV2(url);
      // Check valid response structure
      if (
        response &&
        response.data &&
        response.status === "success" &&
        Array.isArray(response.data)
      ) {
        return response.data; // ✅ return the array directly
      } else {
        console.warn("Unexpected API response structure:", response);
        return [];
      }
    } catch (error) {
      console.error("Failed to fetch gateway device categories:", error);
      return [];
    }
  }

  async fetchAssociatedGateways(client_id: number, gateway_id: number) {
    try {
      const response: any = await this.srv.getDataV2(
        `${BaseUrlConstantsService.BASE_PIEZO_SERVICE}/api/get-gateway-macaddresses/${gateway_id}/${client_id}`
      );

      // Validate and return only the body array
      if (
        response &&
        response.data &&
        response.status === "success" &&
        Array.isArray(response.data)
      ) {
        return response.data; // ✅ return the gateways list
      } else {
        console.warn("Unexpected response format:", response);
        return [];
      }
    } catch (error) {
      console.error("Error fetching associated gateways:", error);
      return [];
    }
  }

  async fetchUserSites(url: string) {
    try {
      const response: any = await this.srv.getDataV2(url);

      // ✅ Validate response structure and ensure it's an array
      if (
        response &&
        response.data &&
        response.data.status === "success" &&
        Array.isArray(response.data.body)
      ) {
        return response.data.body; // Return the list of sites
      } else {
        console.warn("Unexpected response format:", response);
        return [];
      }
    } catch (error) {
      console.error("Error fetching user sites:", error);
      return [];
    }
  }

  async fetchAllBearingNumbers(url: string) {
    try {
      const response: any = await this.srv.getDataV2(url);

      // ✅ Validate the structure
      if (
        response &&
        response.data &&
        response.data.status === "success" &&
        Array.isArray(response.data.body)
      ) {
        // Extract only the bearing numbers (optional)
        const bearingNumbers = response.data.body.map(
          (item: any) => item.bearing_number
        );
        return bearingNumbers;
      } else {
        console.warn("Unexpected response format:", response);
        return [];
      }
    } catch (error) {
      console.error("Error fetching bearing numbers:", error);
      return [];
    }
  }

  async fetchAllDeviceInventory(url: string) {
    try {
      const response: any = await this.srv.getDataV2(url);

      // ✅ Validate the structure
      if (
        response &&
        response.data &&
        response.data.status === "success" &&
        Array.isArray(response.data.body)
      ) {
        // ✅ Filter devices where master_type === 5
        const filteredDevices = response.data.body.filter(
          (item: any) => item.master_type == 4
        );

        return filteredDevices;
      } else {
        console.warn("Unexpected response format:", response);
        return [];
      }
    } catch (error) {
      console.error("Error fetching device inventory:", error);
      return [];
    }
  }
  async savePiezo(url: string, body: any) {
    try {
      const response: any = await this.srv.postData(url, body);

      // ✅ Validate expected structure
      if (response && response.status === "success") {
        // Since your response contains no list/array, just return true or message
        return {
          success: true,
          message: response.message || "Operation Successful",
        };
      } else {
        console.warn("Unexpected response format:", response);
        return {
          success: false,
          message: "Unexpected response structure",
        };
      }
    } catch (error) {
      console.error("Error while saving piezo:", error);
      return {
        success: false,
        message: "Request failed",
      };
    }
  }

  async fetchSystemGateways(url: string) {
    try {
      const response: any = await this.srv.getDataV2(url);

      // Validate structure
      if (
        response &&
        response.status === "success" &&
        response.data &&
        Array.isArray(response.data.configured_gateways)
      ) {
        return response.data.configured_gateways; // <-- return array
      } else {
        console.warn("Unexpected response format:", response);
        return [];
      }
    } catch (error) {
      console.error("Error fetching system gateways:", error);
      return [];
    }
  }

  async freeGatewayStatus(url) {
    try {
      const response: any = await this.srv.patchDataV2(url, {});
      if (response && response.status == "success") {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  }

  async fetchSensorFormData(url) {
    try {
      const response: any = await this.srv.getDataV2(url);

      // Response structure:
      // {
      //   code: 200,
      //   status: "success",
      //   data: {...}
      // }

      if (response && response.status === "success" && response.data) {
        return response.data; // <-- return the mapped object directly
      }

      return null; // failure
    } catch (error) {
      return null; // on error
    }
  }

async fetchEmsaverDeviceInventory(url) {
  try {
    const response: any = await this.srv.getDataV2(url);
    console.log(response)
    // Expected response:
    // {
    //   data: {
    //     code: 200,
    //     status: "success",
    //     body: [...]
    //   }
    // }

    if (
      response &&
      response.data &&
      response.data.status === "success" &&
      Array.isArray(response.data.body)
    ) {
    return {
      emsaver_mini:  response.data.body.filter(s => s.master_type == 1),
      emsaver_std:   response.data.body.filter(s => s.master_type == 2),
      emsaver_rtds:  response.data.body.filter(s => s.master_type == 3),
    };
   // <-- return the array
    }

    return []; // return empty array on failure
  } catch (error) {
    return []; // return empty array on error
  }
}

}
